<template>
  <div class="lg:w-1/2 flex flex-col justify-between">
    <div class="flex flex-col p-8" style="z-index: 99">
      <div class="flex justify-between mb-4">
        <p class="font-bold text-xl md:text-2xl">Récapitulatif de ma commande</p>
      </div>

      <div>
        <div v-for="product in cartProducts" :key="product.id" class="flex justify-between items-center mb-2">
          <p class="font-bold w-[35%] md:w-[50%] break-words">{{ product.name }}</p>
          <div class="flex w-[65%] md:w-[50%]  justify-between items-center">

            <Field :id="'quantity-' + product.id" class="selectForm !p-1 mr-2"
              :class="isDiscount ? '!w-[35%]' : '!w-[50%]'" :name="'quantity'" as="select" :value="product.quantity"
              @change="changeProduct(product)">
              <option v-for="option in product.quantity_max" :key="option" :value="option">
                {{ option }}
              </option>
            </Field>

            <div class="flex text-red font-bold items-center  justify-between"
              :class="isDiscount ? '!w-[65%]' : '!w-[50%]'">
              <div v-if="isDiscount" class="flex gap-2 justify-end w-full">
                <p class="text-red font-bold"
                  :class="getProductPriceDiscount(product) < getProductPrice(product) ? 'line-through text-black' : ''">
                  {{ getProductPrice(product).toFixed(2) }}€</p>
                <p v-if="getProductPriceDiscount(product) < getProductPrice(product)" class="text-red font-bold">{{
                  getProductPriceDiscount(product).toFixed(2) }}€</p>
              </div>
              <div v-else class="flex gap-2 justify-end w-full">
                <p class="text-red font-bold">{{ getProductPrice(product).toFixed(2) }}€</p>
              </div>
              <img src="@/assets/img/delete.png" class="w-4 h-4 ml-2 cursor-pointer"
                @click="removeFromCart(product.id)" />
            </div>
          </div>
        </div>
      </div>

      <!-- Réduction voucher (pour les gagnants wheel) -->
      <div v-if="hasVoucherDiscount && isVoucherMinimumReached">
        <hr class="my-4" />
        <div class="flex justify-between mb-2">
          <p class="font-bold border-b border-red">Bon de réduction</p>
          <div>
            <p class="font-bold">-{{ voucherDiscountAmount.toFixed(0) }}€</p>
          </div>
        </div>
      </div>

      <hr class="my-4" />

      <div class="flex justify-between">
        <p class="font-bold">Livraison à domicile sous 48H</p>
        <div v-if="shippingCost > 0">
          <p class="text-red font-bold">
            {{ shippingCost.toFixed(2) }}€
          </p>
        </div>
        <div v-else>
          <p class="text-red font-bold">0€</p>
        </div>
      </div>
      <p class="italic text-md font-bold text-red mt-3" v-if="$campaign.is_free_shipping_cost">
        Frais de livraison offerts dès {{ $campaign.brink_shipping_cost }}€ d'achat.
      </p>

      <hr class="my-4" />

      <div v-if="isDiscount" class="flex justify-between">
        <p class="font-bold">Total panier</p>
        <div>
          <p class="font-bold">{{ getTotal.toFixed(2) }}€</p>
        </div>
      </div>

      <div v-if="isDiscount" class="flex justify-between mb-2">
        <p class="font-bold border-b border-red">Réduction</p>
        <div>
          <p class="font-bold">-{{ (getTotal - getTotalWithDiscount).toFixed(2) }}€</p>
        </div>
      </div>

      <div class="flex justify-between">
        <p class="font-bold text-xl">Total</p>
        <div class="text-xl">
          <p v-if="isDiscount || hasVoucherDiscount" class="text-red font-bold">{{ getFinalTotal.toFixed(2) }}€</p>
          <p v-else class="text-red font-bold">{{ getTotal.toFixed(2) }}€</p>
        </div>
      </div>
    </div>

    <div class="mb-2">
      <div class="hidden lg:flex justify-center bg-white items-center p-2">
        <img src="@/assets/img/rea1.png" alt="" class="w-[46%]">
        <img src="@/assets/img/rea2.png" alt="" class="w-[46%]">
      </div>
      <div class="hidden lg:flex justify-center bg-white items-center p-2">
        <img src="@/assets/img/rea3.png" alt="" class="w-[46%]">
        <img src="@/assets/img/rea4.png" alt="" class="w-[46%] cursor-pointer" @click="
          openModal(
            'Contact',
            $template.contact,
            $template.contact_picture
          )
          ">
      </div>
    </div>
  </div>
</template>

<script>
import { Field } from 'vee-validate'
export default {
  emits: ['openNotification', 'openModal'],
  components: {
    Field
  },
  computed: {
    isDiscount() {
      return !this.isWheelWinner && this.$store.recall2 && this.$template.discount && this.$template.discount > 0
    },
    campaignDiscountAmount() {
      if (!this.isDiscount) return 0
      return this.getTotalWithoutShipping * (this.$template.discount / 100)
    },
    // Vérifie si c'est un winner wheel
    isWheelWinner() {
      return this.$store.isWheelWinner && this.$store.wheelWinner?.token
    },
    // Vérifie si on a un voucher wheel
    hasVoucherDiscount() {
      return this.$store.isWheelWinner && this.$store.winnerVoucher
    },
    // Vérifie si le minimum d'achat est atteint pour le voucher
    isVoucherMinimumReached() {
      if (!this.hasVoucherDiscount) return true
      const minimumPurchase = this.$store.winnerVoucher?.minimum_purchase || 0
      return this.getTotalWithoutShipping >= minimumPurchase
    },
    // Montant de la réduction voucher
    voucherDiscountAmount() {
      if (!this.hasVoucherDiscount || !this.isVoucherMinimumReached) return 0
      const voucherValue = this.$store.winnerVoucher?.value || 0
      return Math.min(voucherValue, this.getTotalWithoutShipping)
    },
    subtotalAfterDiscounts() {
      return Math.max(0, this.getTotalWithoutShipping - this.campaignDiscountAmount - this.voucherDiscountAmount)
    },
    shippingCost() {
      if (this.subtotalAfterDiscounts < this.$campaign.brink_shipping_cost || !this.$campaign.is_free_shipping_cost) {
        return this.$campaign.shipping_cost
      }
      return 0
    },
    // Total final avec toutes les réductions
    getFinalTotal() {
      return parseFloat((this.subtotalAfterDiscounts + this.shippingCost).toFixed(2))
    },
    cartProducts() {
      return this.$store.cartProducts
    },
    getTotal() {
      return parseFloat((this.getTotalWithoutShipping + this.shippingCost).toFixed(2))
    },
    getTotalWithDiscount() {
      return parseFloat((this.getTotalWithoutShipping - this.campaignDiscountAmount + this.shippingCost).toFixed(2))
    },
    getTotalWithoutShipping() {
      let total = 0
      // let discount = 0

      this.cartProducts.forEach((product) => {
        total += product.reduced_price != null ? product.reduced_price * product.quantity : product.crossed_price * product.quantity
      })

      // if (this.$store.recall2 && this.$template.discount && this.$template.discount > 0) {
      //   discount = total * (this.$template.discount / 100)
      // }

      // total = total - discount.toFixed(2)

      return parseFloat(total.toFixed(2))
    }
  },
  methods: {
    getProductPriceDiscount(product) {
      let price = 0
      let discount = 0

      if (product.reduced_price != null) {
        price = product.reduced_price * product.quantity
      } else {
        price = product.crossed_price * product.quantity
      }

      if (this.$store.recall2 && this.$template.discount && this.$template.discount > 0) {
        discount = price * (this.$template.discount / 100)
      }
      price = price - discount.toFixed(2)
      return parseFloat(price.toFixed(2))
    },
    getProductPrice(product) {
      let price = 0

      if (product.reduced_price != null) {
        price = product.reduced_price * product.quantity
      } else {
        price = product.crossed_price * product.quantity
      }
      return parseFloat(price.toFixed(2))
    },
    async changeProduct(productToChange) {
      let quantity = document.getElementById('quantity-' + productToChange.id)
      let product = {
        id: productToChange.id,
        quantity: quantity.value
      }

      this.$emit(
        'openNotification',
        "L'article " +
        this.$store.getProductById(product.id).name +
        ' a bien été ajouté à votre panier.'
      )

      try {
        // Pour les winners wheel, utiliser l'API wheel
        if (this.isWheelWinner) {
          // Mettre à jour le panier local puis synchro
          const newCart = this.$store.cart.filter(item => item.id !== product.id)
          newCart.push(product)
          const res = await this.$api.wheelUpdateCart(
            this.$store.wheelWinner.token,
            newCart
          )
          this.$store.updateCart(res.data.cart)
        } else {
          const res = await this.$api.syncCart(this.$store.participation.id, {
            action: 'add',
            product
          })
          this.$store.updateCart(res.data.cart)
        }

        //add to cart
        if (!window.location.href.includes('localhost') && !window.location.href.includes('digiworks')) {
          this.$gtm.trackEvent({
            event: "add_to_cart",
            campaignid: this.$campaign.code
          });
        }

      } catch (e) {
        console.log(e)
      }
    },
    async removeFromCart(id) {
      try {
        // Pour les winners wheel, utiliser l'API wheel
        if (this.isWheelWinner) {
          const newCart = this.$store.cart.filter(item => item.id !== id)
          const res = await this.$api.wheelUpdateCart(
            this.$store.wheelWinner.token,
            newCart
          )
          this.$store.updateCart(res.data.cart)
        } else {
          const res = await this.$api.syncCart(this.$store.participation.id, {
            action: 'remove',
            product: { id, quantity: 0 }
          })
          this.$store.updateCart(res.data.cart)
        }
      } catch (e) {
        console.log(e)
      }
    },
    openModal(title, message, img) {
      this.$emit('openModal', title, message, img)
    }
  },
}
</script>
